var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomOff = function SvgCustomOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C919F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.632 10.976h1.738a2.303 2.303 0 0 0 2.606-1.955 2.7 2.7 0 0 0 0-.652V6.631a2.303 2.303 0 0 0-1.955-2.607 2.7 2.7 0 0 0-.651 0h-1.738a2.303 2.303 0 0 0-2.606 1.955 2 2 0 0 0 0 .652v1.738a2.303 2.303 0 0 0 1.955 2.607q.326.039.651 0M6.632 21.976H8.37a2.303 2.303 0 0 0 2.606-1.955 2.7 2.7 0 0 0 0-.652v-1.738a2.304 2.304 0 0 0-1.955-2.607 2.7 2.7 0 0 0-.651 0H6.632a2.303 2.303 0 0 0-2.606 1.955 2 2 0 0 0 0 .652v1.738a2.303 2.303 0 0 0 1.955 2.607q.325.039.651 0M7.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M18.5 22a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
  })));
};
export default SvgCustomOff;